import React from "react";
import ReactDOM from "react-dom/client";

import "ag-grid-enterprise";
import { AllEnterpriseModule, LicenseManager, ModuleRegistry, provideGlobalGridOptions } from "ag-grid-enterprise";

import "../vite-env.d.ts";
import App from "./App";
import { initGTM } from "./gtm";

import "@sabre/spark/dist/css/spark.kopis.min.css";
import "highcharts/css/annotations/popup.css";
import "highcharts/css/stocktools/gui.css";
import "smart-webcomponents-react/source/styles/smart.default.css";

import "./styles/styles.scss";

import { ERROR_TEXT } from "@utils/Constants.js";
import ErrorBoundary from "@utils/error-boundary/ErrorBoundary";

ModuleRegistry.registerModules([AllEnterpriseModule]);

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container!);

const licenseKey = import.meta.env.VITE_AG_GRID_ENTERPRISE_LICENSE_KEY;
// TODO : change this when we have a proper license extraction method
const filteredKey = licenseKey?.replace("VITE_AG_GRID_ENTERPRISE_LICENSE_KEY=", "");

LicenseManager.setLicenseKey(filteredKey);

provideGlobalGridOptions({ theme: "legacy" });

root.render(
  <React.StrictMode>
    <ErrorBoundary fallbackMessage={ERROR_TEXT.APPLICATION}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

initGTM();
